import Vue from 'vue'
import {router} from '@/router'

export const namespaced = true

export const state = {
    activeUser: null,
    userLoading: false,
    usersLoading: false,
    usersAvatarLoading: false,
    paymentLoading: false,
    paymentInfos: {
        reglement: 'prelevement',
        typecarte: 'Mastercard',
        nocarte: '',
        expiration: '01',
        expireYear: '20',
        iban: '',
        bic: '',
        cryptogramme: ''
    }
}

export const mutations = {
    SET_USER_LOADING(state, loading) {
        state.userLoading = loading
    },
    SET_USERS_LOADING(state, loading) {
        state.usersLoading = loading
    },
    SET_USER_AVATAR_LOADING(state, loading) {
        state.usersAvatarLoading = loading
    },

    SET_USER_DATA(state, userData) {
        state.activeUser = userData

        localStorage.setItem('user', JSON.stringify(userData))
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${userData.token}`
    },

    SET_LOGIN_AS_TOKEN(state, token) {
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },

    CLEAR_LOGIN_AS_TOKEN() {
        Vue.axios.defaults.headers.common['Authorization'] = ''
    },

    CLEAR_USER_DATA() {
        localStorage.removeItem('user')
        router.push({path: '/pages/login'})
    },

    UPDATE_USER_INFO(state, payload) {
        // Get Data localStorage
        const userInfo = JSON.parse(localStorage.getItem('user')) || state.activeUser

        for (const property of Object.keys(payload)) {
            if (payload[property] !== null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.activeUser[property] = payload[property]
                // Update key in localStorage
                userInfo[property] = payload[property]
            }
        }
        // Store data in localStorage
        localStorage.setItem('user', JSON.stringify(userInfo))
    },

    SET_PAYMENT_LOADING(state, loading) {
        state.paymentLoading = loading
    },

    UPDATE_PAYMENT_DATA(state, payload) {
        state.paymentInfos = payload
    }
}

export const actions = {
    register({commit}, credentials) {
        return Vue.axios
            .post('/register', credentials)
            .then(({data}) => {
                commit('SET_USER_DATA', data)
            })
    },

    login({commit}, credentials) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.post('/login', credentials)
            .then(({data}) => {
                commit('SET_USER_LOADING', false)
                commit('SET_USER_DATA', data)
            })
    },

    loginAs({commit}, credentials) {
        commit('SET_USER_LOADING', true)
        commit('SET_LOGIN_AS_TOKEN', credentials.token)
        return Vue.axios.post('/login_as', credentials)
            .then(({data}) => {
                commit('SET_USER_LOADING', false)
                commit('CLEAR_LOGIN_AS_TOKEN')
                commit('SET_USER_DATA', data)
            })
    },

    logout({commit, dispatch}) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.post('/logout')
            .then(() => {
                commit('SET_USER_LOADING', false)
                commit('CLEAR_USER_DATA')
            }).catch(error => {
                commit('SET_USERS_LOADING', false)
                commit('CLEAR_USER_DATA')
                dispatch('displayError', {
                    message: 'Déconnexion forcée', error: `Route innexistante dans l’api - ${error}`
                }, {root: true})
            })
    },

    recoverpass({commit, dispatch}, email) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.post('/request-password-reset', email)
            .then(response => {
                commit('SET_USER_LOADING', false)
                if (response.status !== 404 && response.status !== 499) {
                    dispatch('displaySuccess', 'Un lien de réinitialisation de mot de passe vous a été envoyé par email', {root: true})
                } else {
                    dispatch('displayError', {message: 'Email inexistant', error: response.data.error}, {root: true})
                }
            }).catch(error => {
                commit('SET_USERS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de récupération du mot de passe', error}, {root: true})
            })
    },
    resetpass({commit, dispatch}, credentials) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.post('/reset-password', credentials)
            .then(response => {
                commit('SET_USER_LOADING', false)
                if (response.status !== 404 && response.status !== 499) {
                    dispatch('displaySuccess', 'Votre mot de passe a été réinitialisé', {root: true})
                    return response;
                } else {
                    dispatch('displayError', {message: 'Email inexistant', error: response.data.error}, {root: true})
                }
            }).catch(error => {
                commit('SET_USERS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de réinitialisation du mot de passe', error}, {root: true})
            })
    },
    restoreState({dispatch, commit}) {
        const userStr = localStorage.getItem('user')
        if (userStr) {
            const tempLocalUser = JSON.parse(userStr)
            commit('SET_USER_DATA', tempLocalUser)

            //refresh local storage datas with fresh dbdatas 2 secs after loading
            if (tempLocalUser.id && tempLocalUser.token) {
                Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${tempLocalUser.token}`
                dispatch('getUser', tempLocalUser.id)
            }
        }
    },

    getUser({commit, dispatch}, userid) {
        commit('SET_USERS_LOADING', true)
        return Vue.axios.get(`/users/${userid}`)
            .then(response => {
                commit('UPDATE_USER_INFO', response.data)
                commit('SET_USERS_LOADING', false)
            })
            .catch(error => {
                commit('SET_USERS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement de l’utilisateur', error}, {root: true})
                commit('CLEAR_USER_DATA')
            })
    },

    getUsers({commit, dispatch}, {page, limit}) {
        commit('SET_USERS_LOADING', true)
        return Vue.axios.get(`/users??page=${page}&limit=${limit}`)
            .then(response => {
                commit('SET_USERS_LIST', response.data)
                commit('SET_USERS_TOTAL', response.headers['x-total-count'])
                commit('SET_USERS_LOADING', false)
            })
            .catch(error => {
                commit('SET_USERS_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement des utilisateurs', error}, {root: true})
            })
    },

    createUser({commit, dispatch}, payload) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.post('/users', payload)
            .then(() => {
                commit('SET_USER_LOADING', false)
                dispatch('displaySuccess', 'Nouvel utilisateur créé', {root: true})
            })
            .catch(error => {
                commit('SET_USER_LOADING', false)
                dispatch('displayError', {message: 'Erreur de création d’utilisateur', error}, {root: true})
                throw error
            })
    },

    updateUser({commit, dispatch}, payload) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.put(`/users/${payload.id}`, payload)
            .then(() => {

                commit('SET_USER_LOADING', false)

                //update local user infos
                commit('UPDATE_USER_INFO', payload)
                dispatch('displaySuccess', 'Profil mis à jour', {root: true})
            })
            .catch(error => {
                commit('SET_USER_LOADING', false)
                dispatch('displayError', {message: 'Erreur de modification de l’utilisateur', error}, {root: true})
                throw error
            })
    },
    changePassword({commit, dispatch}, payload) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.put(`/users/password`, payload)
            .then(() => {
                commit('SET_USER_LOADING', false)
                dispatch('displaySuccess', 'Mot de passe mis à jour', {root: true})
            })
            .catch(error => {
                commit('SET_USER_LOADING', false)
                dispatch('displayError', {message: 'Erreur de modification du mot de passe', error}, {root: true})
                throw error
            })
    },
    changeUserCredentials({commit, dispatch}, payload) {
        commit('SET_USER_LOADING', true)
        return Vue.axios.put(`/users/${payload.id}/credentials`, payload)
            .then(() => {
                commit('SET_USER_LOADING', false)
                dispatch('displaySuccess', 'Identifiants mis à jour', {root: true})
            })
            .catch(error => {
                commit('SET_USER_LOADING', false)
                dispatch('displayError', {message: 'Erreur de modification des identifiants', error}, {root: true})
                throw error
            })
    },
    updateUserAvatar({commit, dispatch}, payload) {
        commit('SET_USER_AVATAR_LOADING', true)

        const formData = new FormData()
        formData.append('avatar', payload.avatar)

        return Vue.axios.post(`/users/${payload.id}/avatar`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(() => {

                commit('SET_USER_AVATAR_LOADING', false)
                dispatch('displaySuccess', 'Image de l’utilisateur mise à jour avec succès', {root: true})
            })
            .catch(error => {
                commit('SET_USER_AVATAR_LOADING', false)
                dispatch('displayError', {message: 'Erreur d’enregistrement de l’image', error}, {root: true})
                throw error
            })
    },

    getPaymentInfos({commit, dispatch}, userid) {
        commit('SET_PAYMENT_LOADING', true)
        return Vue.axios.get(`/users/${userid}`)
            .then(response => {
                commit('UPDATE_PAYMENT_DATA', {
                    id: response.data.id,
                    reglement: response.data.reglement,
                    typecarte: response.data.typecarte,
                    nocarte: response.data.nocarte,
                    expiration: response.data.expiration,
                    expireYear: response.data.expireYear,
                    iban: response.data.iban,
                    bic: response.data.bic,
                    cryptogramme: response.data.cryptogramme
                })
                commit('SET_PAYMENT_LOADING', false)
            })
            .catch(error => {
                commit('SET_PAYMENT_LOADING', false)
                dispatch('displayError', {message: 'Erreur de chargement des données de paiement', error}, {root: true})
            })
    },

    updatePaymentInfos({commit, dispatch}, payload) {
        commit('SET_PAYMENT_LOADING', true)
        return Vue.axios.put(`/users/${payload.id}`, payload)
            .then(() => {

                commit('SET_PAYMENT_LOADING', false)

                //update local payment infos
                commit('UPDATE_PAYMENT_DATA', payload)
                dispatch('displaySuccess', 'Informations de paiement mis à jour avec succès', {root: true})
            })
            .catch(error => {
                commit('SET_PAYMENT_LOADING', false)
                dispatch('displayError', {
                    message: 'Erreur d’enregistrement de la methode de paiement', error
                }, {root: true})
                throw error
            })
    }
}

export const getters = {
    loggedIn: state => !!state.activeUser,
    activeUser: state => state.activeUser,
    userFullName: state => `${state.activeUser.prenom} ${state.activeUser.nom}`
}
